// (() => {
//   'use strict';

//   const managedNames = ['Original price', 'You save'];

//   const formatMoney = (cents) => {
//     const shopifyCurrency = window.Shopify && window.Shopify.currency;
//     const currency = typeof shopifyCurrency === 'object'
//       ? shopifyCurrency.active
//       : shopifyCurrency;

//     try {
//       return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
//         style: 'currency',
//         currency: currency || 'USD'
//       }).format(Number(cents) / 100);
//     } catch (error) {
//       return '$' + (Number(cents) / 100).toFixed(2);
//     }
//   };

//   const removeManagedProperties = (form) => {
//     form.querySelectorAll('[data-sz-checkout-price]').forEach((input) => input.remove());
//   };

//   const setProperty = (form, name, value) => {
//     let input = form.querySelector('input[data-sz-checkout-price][data-property-name="' + name + '"]');

//     if (!input) {
//       input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = 'properties[' + name + ']';
//       input.dataset.szCheckoutPrice = '';
//       input.dataset.propertyName = name;
//       form.appendChild(input);
//     }

//     input.value = value;
//   };

//   const syncCheckoutPrices = (form) => {
//     if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"]')) return;

//     const component = form.closest('[data-js-product-component]');
//     const variantData = component && component.querySelector('[data-js-variant-data]');

//     if (!variantData) {
//       removeManagedProperties(form);
//       return;
//     }

//     try {
//       const variant = JSON.parse(variantData.textContent);
//       const price = Number(variant.price);
//       const compareAtPrice = Number(variant.compare_at_price);

//       removeManagedProperties(form);

//       if (!Number.isFinite(price) || !Number.isFinite(compareAtPrice) || compareAtPrice <= price) return;

//       setProperty(form, managedNames[0], formatMoney(compareAtPrice));
//       setProperty(form, managedNames[1], formatMoney(compareAtPrice - price));
//     } catch (error) {
//       removeManagedProperties(form);
//     }
//   };

//   document.addEventListener('click', (event) => {
//     const button = event.target.closest('[data-js-product-add-to-cart]');
//     if (button) syncCheckoutPrices(button.form || button.closest('form'));
//   }, true);

//   document.addEventListener('submit', (event) => {
//     syncCheckoutPrices(event.target);
//   }, true);
// })();

// /* Sleep Zone free-gift safety + recovery v3.2 */
// (() => {
//   'use strict';
//   if (window.__szGiftSafetyV32) return;
//   window.__szGiftSafetyV32 = true;

//   const C = {
//     threshold: 9900,
//     productId: 8031994970174,
//     variantId: 42539317788734,
//     marker: '_sz_free_gift',
//     dismissed: 'sz_free_gift_dismissed_v3',
//     conflict: 'sz_free_gift_conflict_v3',
//     bypass: 'X-SZ-Free-Gift'
//   };
//   const f = window.fetch.bind(window);
//   const root = () => window.Shopify?.routes?.root || '/';
//   const url = (p) => `${root()}cart${p}`;
//   const flag = (k, v) => {
//     try {
//       if (v === undefined) return sessionStorage.getItem(k) === '1';
//       if (v) sessionStorage.setItem(k, '1'); else sessionStorage.removeItem(k);
//     } catch (_) { return false; }
//   };
//   const gift = (i) => Number(i?.product_id) === C.productId &&
//     String(i?.properties?.[C.marker]) === 'true';
//   const gifts = (c) => (c?.items || []).filter(gift);
//   const eligible = (c) => (c?.items || []).reduce(
//     (s, i) => s + (gift(i) ? 0 : Number(i.final_line_price || 0)), 0
//   ) >= C.threshold;
//   const free = (i) => Number(i?.final_line_price || 0) === 0;

//   const req = async (p, body) => {
//     const r = await f(url(p), {
//       method: body ? 'POST' : 'GET',
//       credentials: 'same-origin',
//       headers: {
//         Accept: 'application/json',
//         ...(body ? {'Content-Type':'application/json'} : {}),
//         [C.bypass]: '1'
//       },
//       body: body ? JSON.stringify(body) : undefined
//     });
//     if (!r.ok) throw new Error(`Cart request failed: ${r.status}`);
//     return r.json();
//   };
//   const cart = () => req('.js');
//   const remove = (key) => req('/change.js', {id:key, quantity:0});
//   const add = () => req('/add.js', {items:[{
//     id:C.variantId, quantity:1, properties:{[C.marker]:'true'}
//   }]});
//   const removeAll = async (c) => {
//     let changed = false;
//     for (const i of gifts(c)) { await remove(i.key); changed = true; }
//     return changed;
//   };
//   const refresh = async () => {
//     if (typeof window.refreshCart === 'function') await window.refreshCart(false);
//     else if (document.body.classList.contains('template-cart')) location.reload();
//   };

//   let last = null;
//   let running = null;
//   let timer = 0;
//   let checkingOut = false;
//   let manualRemoveBusy = false;
//   let restoring = false;

//   const repair = (c = last) => {
//     if (!c) return;
//     const marked = new Set(gifts(c).map(i => i.key));
//     document.querySelectorAll(
//       `[data-js-cart-item][data-product-id="${C.productId}"]`
//     ).forEach(row => {
//       if (!marked.has(row.dataset.id)) return;
//       row.dataset.szFreeGift = 'true';
//       const a = row.querySelector('.remove');
//       if (a) {
//         a.removeAttribute('aria-disabled');
//         a.style.pointerEvents = 'auto';
//         a.href = '#';
//         a.dataset.szGiftRemove = 'true';
//       }
//     });
//   };

//   const recovery = (c = last) => {
//     if (!c) return;
//     const show = eligible(c) && !gifts(c).length &&
//       (flag(C.dismissed) || flag(C.conflict));
//     document.querySelectorAll('.cart__items,.cart-form__items').forEach(box => {
//       let b = box.querySelector('.sz-free-gift-recovery');
//       if (!show) { b?.remove(); return; }
//       if (!b) {
//         b = document.createElement('div');
//         b.className = 'sz-free-gift-recovery text-size--small';
//         b.innerHTML = '<span class="sz-gwp-title"></span> ' +
//           '<button type="button" class="text-link sz-gwp-readd">Add free gift back</button>' +
//           '<span class="sz-gwp-message" aria-live="polite"></span>';
//         box.prepend(b);
//       }
//       b.querySelector('.sz-gwp-title').textContent =
//         flag(C.conflict) ? 'Free gift unavailable with current promotion.' : 'Free gift removed.';
//       b.querySelector('.sz-gwp-message').textContent =
//         flag(C.conflict) ? 'Your current promotion can’t be combined with the free gift.' : '';
//     });
//   };

//   const setRecoveryMessage = (text) => {
//     document.querySelectorAll('.sz-free-gift-recovery .sz-gwp-message')
//       .forEach(el => { el.textContent = text || ''; });
//   };

//   const paint = async (c, changed, doRefresh) => {
//     last = c;
//     if (changed && doRefresh) {
//       await refresh();
//       try { last = await cart(); } catch (_) {}
//     }
//     repair(last); recovery(last);
//     return last;
//   };

//   const sync = async ({allowAdd=false, doRefresh=false}={}) => {
//     if (running) return running;
//     running = (async () => {
//       let c = await cart(), changed = false;

//       if (!eligible(c)) {
//         flag(C.dismissed,false); flag(C.conflict,false);
//         if (gifts(c).length) { changed = await removeAll(c); c = await cart(); }
//         c = await paint(c, changed, doRefresh);
//         return {cart:c, conflict:false};
//       }

//       if (flag(C.dismissed) || flag(C.conflict)) {
//         if (gifts(c).length) { changed = await removeAll(c); c = await cart(); }
//         c = await paint(c, changed, doRefresh);
//         return {cart:c, conflict:flag(C.conflict)};
//       }

//       if (gifts(c).some(i => !free(i))) {
//         await removeAll(c); flag(C.conflict,true); changed = true; c = await cart();
//         c = await paint(c, changed, doRefresh);
//         return {cart:c, conflict:true};
//       }

//       if (allowAdd && !gifts(c).length) {
//         try { await add(); changed = true; c = await cart(); } catch (_) {}
//         if (gifts(c).some(i => !free(i))) {
//           await removeAll(c); flag(C.conflict,true); changed = true; c = await cart();
//         }
//       }

//       if (gifts(c).some(i => !free(i))) {
//         await removeAll(c); flag(C.conflict,true); changed = true; c = await cart();
//       }

//       c = await paint(c, changed, doRefresh);
//       return {cart:c, conflict:flag(C.conflict)};
//     })();
//     try { return await running; } finally { running = null; }
//   };

//   const schedule = (ms=180) => {
//     if (restoring) return;
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       if (restoring) return;
//       // sync({doRefresh:true}).catch(() => {});
//       sync({
//         allowAdd: !flag(C.dismissed) && !flag(C.conflict),
//         doRefresh: true
//       }).catch(() => {});
//     }, ms);
//   };

//   const restoreGift = async (btn) => {
//     if (restoring) return;
//     restoring = true;
//     clearTimeout(timer);
//     btn.disabled = true;
//     setRecoveryMessage('Adding your free gift…');

//     try {
//       if (running) {
//         try { await running; } catch (_) {}
//       }
//       clearTimeout(timer);

//       let c = await cart();
//       last = c;

//       if (!eligible(c)) {
//         flag(C.dismissed,false);
//         flag(C.conflict,false);
//         recovery(c);
//         setRecoveryMessage('Your cart no longer qualifies for the free gift.');
//         return;
//       }

//       if (gifts(c).some(free)) {
//         flag(C.dismissed,false);
//         flag(C.conflict,false);
//         await refresh();
//         try { last = await cart(); } catch (_) { last = c; }
//         repair(last); recovery(last);
//         return;
//       }

//       if (gifts(c).length) {
//         await removeAll(c);
//         c = await cart();
//       }

//       flag(C.dismissed,false);
//       flag(C.conflict,false);

//       await add();
//       c = await cart();

//       if (!gifts(c).length) {
//         flag(C.dismissed,true);
//         last = c;
//         recovery(last);
//         setRecoveryMessage('We couldn’t add the free gift. Please try again.');
//         return;
//       }

//       if (gifts(c).some(i => !free(i))) {
//         await removeAll(c);
//         flag(C.conflict,true);
//         flag(C.dismissed,false);
//         c = await cart();
//         last = c;
//         await refresh();
//         try { last = await cart(); } catch (_) {}
//         repair(last); recovery(last);
//         setRecoveryMessage('Your current promotion can’t be combined with the free gift.');
//         return;
//       }

//       flag(C.dismissed,false);
//       flag(C.conflict,false);
//       last = c;
//       await refresh();
//       try { last = await cart(); } catch (_) {}
//       repair(last); recovery(last);
//     } catch (err) {
//       flag(C.dismissed,true);
//       flag(C.conflict,false);
//       try {
//         last = await cart();
//         repair(last); recovery(last);
//       } catch (_) {}
//       setRecoveryMessage('We couldn’t add the free gift. Please try again.');
//       console.warn('[Sleep Zone] One-click gift restore failed', err);
//     } finally {
//       restoring = false;
//       document.querySelectorAll('.sz-gwp-readd').forEach(el => { el.disabled = false; });
//     }
//   };

//   const css = document.createElement('style');
//   css.textContent = `
//     [data-sz-free-gift="true"] .cart-item__actions{display:flex!important}
//     [data-sz-free-gift="true"] .cart__quantity,
//     [data-sz-free-gift="true"] .cart-item__price{display:block!important}
//     [data-sz-free-gift="true"] .quantity-selector-holder,
//     [data-sz-free-gift="true"] cart-product-quantity{display:none!important}
//     [data-sz-free-gift="true"] .remove{
//       display:inline-flex!important;visibility:visible!important;
//       pointer-events:auto!important;cursor:pointer!important
//     }
//     .sz-free-gift-recovery{
//       display:flex;flex-wrap:wrap;gap:.35rem .75rem;align-items:center;
//       margin:0 0 1rem;padding:.75rem 1rem;border:1px solid currentColor;border-radius:6px
//     }
//     .sz-gwp-readd{
//       border:0;padding:0;background:none;color:inherit;font:inherit;
//       text-decoration:underline;cursor:pointer
//     }
//     .sz-gwp-readd:disabled{opacity:.6;cursor:wait}
//     .sz-gwp-message{flex-basis:100%;opacity:.75}
//   `;
//   document.head.appendChild(css);

//   window.addEventListener('click', e => {
//     const btn = e.target.closest?.('.sz-gwp-readd');
//     if (btn) {
//       e.preventDefault();
//       e.stopPropagation();
//       e.stopImmediatePropagation();
//       restoreGift(btn);
//       return;
//     }

//     const a = e.target.closest?.('.remove');
//     const row = a?.closest?.(
//       `[data-js-cart-item][data-product-id="${C.productId}"]`
//     );
//     if (!a || !row) return;

//     e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
//     if (manualRemoveBusy) return;
//     manualRemoveBusy = true;

//     (async () => {
//       try {
//         const current = await cart();
//         let item = (current.items || []).find(i => i.key === row.dataset.id);

//         if (!item && row.dataset.line) {
//           const index = Number(row.dataset.line) - 1;
//           const candidate = current.items?.[index];
//           if (candidate && Number(candidate.product_id) === C.productId) item = candidate;
//         }

//         if (!item || Number(item.product_id) !== C.productId) {
//           last = current;
//           repair(last); recovery(last);
//           return;
//         }

//         if (gift(item)) {
//           flag(C.dismissed,true);
//           flag(C.conflict,false);
//         }

//         clearTimeout(timer);
//         await remove(item.key);
//         last = await cart();
//         await refresh();
//         try { last = await cart(); } catch (_) {}
//         repair(last); recovery(last);
//       } catch (err) {
//         console.warn('[Sleep Zone] Exact-key gift removal failed', err);
//       } finally {
//         manualRemoveBusy = false;
//       }
//     })();
//   }, true);

//   const oldFetch = window.fetch.bind(window);
//   window.fetch = function(input, init={}) {
//     const r = oldFetch(input, init);
//     try {
//       const u = typeof input === 'string' ? input : input?.url || '';
//       const method = String(init.method || (typeof input !== 'string' ? input?.method : '') || 'GET').toUpperCase();
//       const h = new Headers(init.headers || (typeof input !== 'string' ? input?.headers : undefined));
//       const p = new URL(u, location.origin).pathname;
//       const mutation = method !== 'GET' && ['/cart/add.js','/cart/change.js','/cart/update.js','/cart/clear.js']
//         .some(x => p.endsWith(x));
//       if (mutation && h.get(C.bypass) !== '1') r.then(() => {
//         schedule(180); setTimeout(() => schedule(0), 600);
//       }).catch(() => {});
//     } catch (_) {}
//     return r;
//   };

//   document.addEventListener('cart-updated', () => schedule(220), true);
//   new MutationObserver(() => {
//     repair();
//     if (document.querySelector(`[data-js-cart-item][data-product-id="${C.productId}"]`) ||
//         flag(C.dismissed) || flag(C.conflict)) schedule(220);
//   }).observe(document.documentElement, {childList:true, subtree:true});

//   const checkoutControl = t => t?.closest?.(
//     '[name="checkout"],#CheckOut,[data-js-cart-checkout],a[href*="/checkout"]'
//   );
//   const checkout = async () => {
//     if (checkingOut) return;
//     checkingOut = true;
//     try {
//       const r = await sync({
//         allowAdd: !flag(C.dismissed) && !flag(C.conflict),
//         doRefresh:false
//       });
//       if (gifts(r.cart).some(i => !free(i))) {
//         await removeAll(r.cart); flag(C.conflict,true);
//       }
//       location.assign(`${root()}checkout`);
//     } catch (err) {
//       checkingOut = false;
//       alert('We could not verify your free gift. Please try checkout again.');
//     }
//   };

//   window.addEventListener('click', e => {
//     if (!checkoutControl(e.target)) return;
//     e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); checkout();
//   }, true);
//   window.addEventListener('submit', e => {
//     if (!e.submitter || !checkoutControl(e.submitter)) return;
//     e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); checkout();
//   }, true);

//   const start = () => { schedule(0); setTimeout(() => schedule(0),350); setTimeout(() => schedule(0),900); };
//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
//   else start();
//   window.addEventListener('pageshow', () => {
//     setTimeout(() => schedule(0),200); setTimeout(() => schedule(0),700);
//   });

//   window.SleepZoneGiftSafety = Object.freeze({
//     sync: () => sync({doRefresh:true}),
//     reset: () => {
//       flag(C.dismissed,false); flag(C.conflict,false);
//       return sync({allowAdd:true,doRefresh:true});
//     },
//     restore: () => {
//       const btn = document.querySelector('.sz-gwp-readd');
//       return btn ? restoreGift(btn) : Promise.resolve();
//     }
//   });
// })();


(() => {
  'use strict';

  const managedNames = ['Original price', 'You save'];

  const formatMoney = (cents) => {
    const shopifyCurrency = window.Shopify && window.Shopify.currency;
    const currency = typeof shopifyCurrency === 'object'
      ? shopifyCurrency.active
      : shopifyCurrency;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents) / 100);
    } catch (error) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  };

  const removeManagedProperties = (form) => {
    form.querySelectorAll('[data-sz-checkout-price]').forEach((input) => input.remove());
  };

  const setProperty = (form, name, value) => {
    let input = form.querySelector('input[data-sz-checkout-price][data-property-name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.dataset.szCheckoutPrice = '';
      input.dataset.propertyName = name;
      form.appendChild(input);
    }

    input.value = value;
  };

  const syncCheckoutPrices = (form) => {
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"]')) return;

    const component = form.closest('[data-js-product-component]');
    const variantData = component && component.querySelector('[data-js-variant-data]');

    if (!variantData) {
      removeManagedProperties(form);
      return;
    }

    try {
      const variant = JSON.parse(variantData.textContent);
      const price = Number(variant.price);
      const compareAtPrice = Number(variant.compare_at_price);

      removeManagedProperties(form);

      if (!Number.isFinite(price) || !Number.isFinite(compareAtPrice) || compareAtPrice <= price) return;

      setProperty(form, managedNames[0], formatMoney(compareAtPrice));
      setProperty(form, managedNames[1], formatMoney(compareAtPrice - price));
    } catch (error) {
      removeManagedProperties(form);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-js-product-add-to-cart]');
    if (button) syncCheckoutPrices(button.form || button.closest('form'));
  }, true);

  document.addEventListener('submit', (event) => {
    syncCheckoutPrices(event.target);
  }, true);
})();

/* Sleep Zone free-gift safety + recovery v3.2 */
(() => {
  'use strict';
  if (window.__szGiftSafetyV32) return;
  window.__szGiftSafetyV32 = true;

  const C = {
    threshold: 9900,
    productId: 8031994970174,
    variantId: 42539317788734,
    marker: '_sz_free_gift',
    dismissed: 'sz_free_gift_dismissed_v3',
    conflict: 'sz_free_gift_conflict_v3',
    bypass: 'X-SZ-Free-Gift'
  };
  const f = window.fetch.bind(window);
  const root = () => window.Shopify?.routes?.root || '/';
  const url = (p) => `${root()}cart${p}`;
  const flag = (k, v) => {
    try {
      if (v === undefined) return sessionStorage.getItem(k) === '1';
      if (v) sessionStorage.setItem(k, '1'); else sessionStorage.removeItem(k);
    } catch (_) { return false; }
  };
  const gift = (i) => Number(i?.product_id) === C.productId &&
    String(i?.properties?.[C.marker]) === 'true';
  const gifts = (c) => (c?.items || []).filter(gift);
  const eligible = (c) => (c?.items || []).reduce(
    (s, i) => s + (gift(i) ? 0 : Number(i.final_line_price || 0)), 0
  ) >= C.threshold;
  const free = (i) => Number(i?.final_line_price || 0) === 0;

  const req = async (p, body) => {
    const r = await f(url(p), {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(body ? {'Content-Type':'application/json'} : {}),
        [C.bypass]: '1'
      },
      body: body ? JSON.stringify(body) : undefined
    });
    if (!r.ok) throw new Error(`Cart request failed: ${r.status}`);
    return r.json();
  };
  const cart = () => req('.js');
  const remove = (key) => req('/change.js', {id:key, quantity:0});
  const add = () => req('/add.js', {items:[{
    id:C.variantId, quantity:1, properties:{[C.marker]:'true'}
  }]});
  const removeAll = async (c) => {
    let changed = false;
    for (const i of gifts(c)) { await remove(i.key); changed = true; }
    return changed;
  };
  const refresh = async () => {
    if (typeof window.refreshCart === 'function') await window.refreshCart(false);
    else if (document.body.classList.contains('template-cart')) location.reload();
  };

  let last = null;
  let running = null;
  let timer = 0;
  let checkingOut = false;
  let manualRemoveBusy = false;
  let restoring = false;

  const repair = (c = last) => {
    if (!c) return;
    const marked = new Set(gifts(c).map(i => i.key));
    document.querySelectorAll(
      `[data-js-cart-item][data-product-id="${C.productId}"]`
    ).forEach(row => {
      if (!marked.has(row.dataset.id)) return;
      row.dataset.szFreeGift = 'true';
      const a = row.querySelector('.remove');
      if (a) {
        a.removeAttribute('aria-disabled');
        a.style.pointerEvents = 'auto';
        a.href = '#';
        a.dataset.szGiftRemove = 'true';
      }
    });
  };

  const recovery = (c = last) => {
    if (!c) return;
    const show = eligible(c) && !gifts(c).length &&
      (flag(C.dismissed) || flag(C.conflict));
    document.querySelectorAll('.cart__items,.cart-form__items').forEach(box => {
      let b = box.querySelector('.sz-free-gift-recovery');
      if (!show) { b?.remove(); return; }
      if (!b) {
        b = document.createElement('div');
        b.className = 'sz-free-gift-recovery text-size--small';
        b.innerHTML = '<span class="sz-gwp-title"></span> ' +
          '<button type="button" class="text-link sz-gwp-readd">Add free gift back</button>' +
          '<span class="sz-gwp-message" aria-live="polite"></span>';
        box.prepend(b);
      }
      b.querySelector('.sz-gwp-title').textContent =
        flag(C.conflict) ? 'Free gift unavailable with current promotion.' : 'Free gift removed.';
      b.querySelector('.sz-gwp-message').textContent =
        flag(C.conflict) ? 'Your current promotion can’t be combined with the free gift.' : '';
    });
  };

  const setRecoveryMessage = (text) => {
    document.querySelectorAll('.sz-free-gift-recovery .sz-gwp-message')
      .forEach(el => { el.textContent = text || ''; });
  };

  const paint = async (c, changed, doRefresh) => {
    last = c;
    if (changed && doRefresh) {
      await refresh();
      try { last = await cart(); } catch (_) {}
    }
    repair(last); recovery(last);
    return last;
  };

  const sync = async ({allowAdd=false, doRefresh=false}={}) => {
    if (running) return running;
    running = (async () => {
      let c = await cart(), changed = false;

      if (!eligible(c)) {
        flag(C.dismissed,false); flag(C.conflict,false);
        if (gifts(c).length) { changed = await removeAll(c); c = await cart(); }
        c = await paint(c, changed, doRefresh);
        return {cart:c, conflict:false};
      }

      if (flag(C.dismissed) || flag(C.conflict)) {
        if (gifts(c).length) { changed = await removeAll(c); c = await cart(); }
        c = await paint(c, changed, doRefresh);
        return {cart:c, conflict:flag(C.conflict)};
      }

      if (gifts(c).some(i => !free(i))) {
        await removeAll(c); flag(C.conflict,true); changed = true; c = await cart();
        c = await paint(c, changed, doRefresh);
        return {cart:c, conflict:true};
      }

      if (allowAdd && !gifts(c).length) {
        // Do not silently treat a failed add as a successful reconciliation.
        await add();
        changed = true;
        c = await cart();
        if (!gifts(c).length) {
          throw new Error('Free gift was not present after the add request.');
        }
        if (gifts(c).some(i => !free(i))) {
          await removeAll(c); flag(C.conflict,true); changed = true; c = await cart();
        }
      }

      if (gifts(c).some(i => !free(i))) {
        await removeAll(c); flag(C.conflict,true); changed = true; c = await cart();
      }

      c = await paint(c, changed, doRefresh);
      return {cart:c, conflict:flag(C.conflict)};
    })();
    try { return await running; } finally { running = null; }
  };

  const schedule = (ms=180) => {
    if (restoring) return;
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (restoring) return;
      try {
        // Wait for an in-flight reconciliation, then re-read the latest cart.
        if (running) {
          try { await running; } catch (_) {}
        }
        await sync({
          allowAdd: !flag(C.dismissed) && !flag(C.conflict),
          doRefresh: true
        });
      } catch (error) {
        console.warn('[Sleep Zone gift safety] Automatic gift sync failed', error);
      }
    }, ms);
  };

  const restoreGift = async (btn) => {
    if (restoring) return;
    restoring = true;
    clearTimeout(timer);
    btn.disabled = true;
    setRecoveryMessage('Adding your free gift…');

    try {
      if (running) {
        try { await running; } catch (_) {}
      }
      clearTimeout(timer);

      let c = await cart();
      last = c;

      if (!eligible(c)) {
        flag(C.dismissed,false);
        flag(C.conflict,false);
        recovery(c);
        setRecoveryMessage('Your cart no longer qualifies for the free gift.');
        return;
      }

      if (gifts(c).some(free)) {
        flag(C.dismissed,false);
        flag(C.conflict,false);
        await refresh();
        try { last = await cart(); } catch (_) { last = c; }
        repair(last); recovery(last);
        return;
      }

      if (gifts(c).length) {
        await removeAll(c);
        c = await cart();
      }

      flag(C.dismissed,false);
      flag(C.conflict,false);

      await add();
      c = await cart();

      if (!gifts(c).length) {
        flag(C.dismissed,true);
        last = c;
        recovery(last);
        setRecoveryMessage('We couldn’t add the free gift. Please try again.');
        return;
      }

      if (gifts(c).some(i => !free(i))) {
        await removeAll(c);
        flag(C.conflict,true);
        flag(C.dismissed,false);
        c = await cart();
        last = c;
        await refresh();
        try { last = await cart(); } catch (_) {}
        repair(last); recovery(last);
        setRecoveryMessage('Your current promotion can’t be combined with the free gift.');
        return;
      }

      flag(C.dismissed,false);
      flag(C.conflict,false);
      last = c;
      await refresh();
      try { last = await cart(); } catch (_) {}
      repair(last); recovery(last);
    } catch (err) {
      flag(C.dismissed,true);
      flag(C.conflict,false);
      try {
        last = await cart();
        repair(last); recovery(last);
      } catch (_) {}
      setRecoveryMessage('We couldn’t add the free gift. Please try again.');
      console.warn('[Sleep Zone] One-click gift restore failed', err);
    } finally {
      restoring = false;
      document.querySelectorAll('.sz-gwp-readd').forEach(el => { el.disabled = false; });
    }
  };

  const css = document.createElement('style');
  css.textContent = `
    [data-sz-free-gift="true"] .cart-item__actions{display:flex!important}
    [data-sz-free-gift="true"] .cart__quantity,
    [data-sz-free-gift="true"] .cart-item__price{display:block!important}
    [data-sz-free-gift="true"] .quantity-selector-holder,
    [data-sz-free-gift="true"] cart-product-quantity{display:none!important}
    [data-sz-free-gift="true"] .remove{
      display:inline-flex!important;visibility:visible!important;
      pointer-events:auto!important;cursor:pointer!important
    }
    .sz-free-gift-recovery{
      display:flex;flex-wrap:wrap;gap:.35rem .75rem;align-items:center;
      margin:0 0 1rem;padding:.75rem 1rem;border:1px solid currentColor;border-radius:6px
    }
    .sz-gwp-readd{
      border:0;padding:0;background:none;color:inherit;font:inherit;
      text-decoration:underline;cursor:pointer
    }
    .sz-gwp-readd:disabled{opacity:.6;cursor:wait}
    .sz-gwp-message{flex-basis:100%;opacity:.75}
  `;
  document.head.appendChild(css);

  window.addEventListener('click', e => {
    const btn = e.target.closest?.('.sz-gwp-readd');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      restoreGift(btn);
      return;
    }

    const a = e.target.closest?.('.remove');
    const row = a?.closest?.(
      `[data-js-cart-item][data-product-id="${C.productId}"]`
    );
    if (!a || !row) return;

    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (manualRemoveBusy) return;
    manualRemoveBusy = true;

    (async () => {
      try {
        const current = await cart();
        let item = (current.items || []).find(i => i.key === row.dataset.id);

        if (!item && row.dataset.line) {
          const index = Number(row.dataset.line) - 1;
          const candidate = current.items?.[index];
          if (candidate && Number(candidate.product_id) === C.productId) item = candidate;
        }

        if (!item || Number(item.product_id) !== C.productId) {
          last = current;
          repair(last); recovery(last);
          return;
        }

        if (gift(item)) {
          flag(C.dismissed,true);
          flag(C.conflict,false);
        }

        clearTimeout(timer);
        await remove(item.key);
        last = await cart();
        await refresh();
        try { last = await cart(); } catch (_) {}
        repair(last); recovery(last);
      } catch (err) {
        console.warn('[Sleep Zone] Exact-key gift removal failed', err);
      } finally {
        manualRemoveBusy = false;
      }
    })();
  }, true);

  const oldFetch = window.fetch.bind(window);
  window.fetch = function(input, init={}) {
    const r = oldFetch(input, init);
    try {
      const u = typeof input === 'string' ? input : input?.url || '';
      const method = String(init.method || (typeof input !== 'string' ? input?.method : '') || 'GET').toUpperCase();
      const h = new Headers(init.headers || (typeof input !== 'string' ? input?.headers : undefined));
      const p = new URL(u, location.origin).pathname;
      const mutation = method !== 'GET' && ['/cart/add.js','/cart/change.js','/cart/update.js','/cart/clear.js']
        .some(x => p.endsWith(x));
      if (mutation && h.get(C.bypass) !== '1') r.then(() => {
        schedule(180); setTimeout(() => schedule(0), 600);
      }).catch(() => {});
    } catch (_) {}
    return r;
  };

  document.addEventListener('cart-updated', () => schedule(220), true);
  new MutationObserver(() => {
    repair();
    if (document.querySelector(`[data-js-cart-item][data-product-id="${C.productId}"]`) ||
        flag(C.dismissed) || flag(C.conflict)) schedule(220);
  }).observe(document.documentElement, {childList:true, subtree:true});

  const checkoutControl = t => t?.closest?.(
    '[name="checkout"],#CheckOut,[data-js-cart-checkout],a[href*="/checkout"]'
  );
  const checkout = async () => {
    if (checkingOut) return;
    checkingOut = true;
    try {
      const r = await sync({
        allowAdd: !flag(C.dismissed) && !flag(C.conflict),
        doRefresh:false
      });
      if (gifts(r.cart).some(i => !free(i))) {
        await removeAll(r.cart); flag(C.conflict,true);
      }
      location.assign(`${root()}checkout`);
    } catch (err) {
      checkingOut = false;
      alert('We could not verify your free gift. Please try checkout again.');
    }
  };

  window.addEventListener('click', e => {
    if (!checkoutControl(e.target)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); checkout();
  }, true);
  window.addEventListener('submit', e => {
    if (!e.submitter || !checkoutControl(e.submitter)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); checkout();
  }, true);

  const start = () => { schedule(0); setTimeout(() => schedule(0),350); setTimeout(() => schedule(0),900); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  window.addEventListener('pageshow', () => {
    setTimeout(() => schedule(0),200); setTimeout(() => schedule(0),700);
  });

  window.SleepZoneGiftSafety = Object.freeze({
    sync: () => sync({doRefresh:true}),
    reset: () => {
      flag(C.dismissed,false); flag(C.conflict,false);
      return sync({allowAdd:true,doRefresh:true});
    },
    restore: () => {
      const btn = document.querySelector('.sz-gwp-readd');
      return btn ? restoreGift(btn) : Promise.resolve();
    }
  });
})();